import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { CampaignListFiltersArray } from './Filters'

const CampaignListFilters: React.FC<Omit<FilterProps, 'children'>> = (
  props
) => {
  return (
    <Filter {...props}>
      {CampaignListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default CampaignListFilters
